import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { generateToken } from "../shared/utils/GenerateTokenFirebase";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await axios.post(`${serverURL}/api/auth/login`, {
        email,
        password,
      });
      const { token, role, userId, emailId, name, superAdminEmail } =
        response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("userId", userId);
      localStorage.setItem("email", emailId);
      localStorage.setItem("name", name);
      localStorage.setItem("superAdminEmail", superAdminEmail);

      if (role === -1) navigate("/adminportal/dashboard");
      else navigate("/adminportal/vendorDetails");
    } catch (err) {
      Swal.fire({
        icon: "error",
        text:
          err?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
      setIsLoading(false);
    }
  };

  return (
    <div
      className="relative h-screen w-full bg-cover bg-center"
      style={{
        backgroundImage: "url('/assests/AdminDashboard/Login-banner.jpg')",
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative flex justify-center items-center h-full">
        <div className="bg-gray-900 text-white p-8 rounded-lg shadow-lg max-w-sm w-full">
          <div className="flex justify-center items-center mb-4">
            <img
              src="/assests/images/LandingPage/PixellLogo.png"
              className=""
              alt="logo"
            ></img>
          </div>
          <h2 className="text-2xl font-bold text-center mb-6">
            Sign in to your account
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-300">Your email</label>
              <input
                type="email"
                className="w-full p-2 mt-2 bg-gray-800 text-white border border-gray-600 rounded"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-300">Password</label>
              <input
                type="password"
                className="w-full p-2 mt-2 bg-gray-800 text-white border border-gray-600 rounded"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              disabled={isLoading}
              type="submit"
              className="w-full p-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
            >
              {isLoading ? (
                <div className="flex justify-center items-center">
                  Please Wait...{" "}
                  <CircularProgress
                    className="ml-2"
                    size={20}
                    color="inherit"
                  />
                </div>
              ) : (
                "Log in to your account"
              )}
            </button>
            <p className="text-center text-gray-400 text-sm mt-4">
              Don't have an account?{" "}
              <a
                href="https://pixell.in"
                className="text-blue-400 hover:underline"
              >
                Go to Website
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
